<template>
  <div :class="componentClassName">
    <div class="a-sf-calling-customer-info__title">
      <span>{{ displayTitle }}</span>
    </div>
    <div v-if="displaySubtitleArea()" class="a-sf-calling-customer-info__subtitle">
      <span class="a-sf-calling-customer-info__subtitle-number">{{ phoneNumber }}</span>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import { utils } from '@/common/utils.js';

export default {
  name: 'a-sf-calling-customer-info',
  components: {},
  mixins: [utils],
  props: {
    class: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    displayName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    minimized: {
      type: Boolean,
      default: false,
    },
    pbSettingName: {
      type: String,
      default: '',
    },
    callIsIncomming: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-sf-calling-customer-info', this.minimized ? 'minimized' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
    pushNumberSettingName() {
      return this.collapseText(this.pbSettingName, 10);
    },
    displayTitle() {
      const titleString = this.title ? this.title : this.displayName;
      if (this.isPhoneNumber(titleString)) return titleString;
      return this.callIsIncomming || this.minimized ? this.collapseText(titleString, 10) : titleString;
    },
    displaySubtitle() {
      return this.callIsIncomming || this.minimized ? this.collapseText(this.subtitle, 10) : this.subtitle;
    },
    subtitleCollapsed() {
      return this.collapseText(this.subtitle, 10);
    },
  },
  methods: {
    displaySubtitleArea() {
      return (
        !this.minimized &&
        ((this.title && !this.isPhoneNumber(this.title)) || (this.displayName && !this.isPhoneNumber(this.displayName)))
      );
    },
  },
};
</script>
